import HTTP from "@/_helpers/http";
import { CURRENCY__API } from "@/_helpers/urls";
import { CURRENCY__MUTATIONS } from "../mutation-types";
import { CURRENCY__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  currencies: [],
  groups: [],
  usdtoinrcurrency: [],
};

// Getters
const getters = {};

// Mutations
const mutations = {
  [CURRENCY__MUTATIONS.ACTIVECURRENCIES](state, data) {
    state.currencies = data;
  },
  [CURRENCY__MUTATIONS.ACTIVECURRENCYGROUPS](state, data) {
    state.groups = data;
  },
  [CURRENCY__MUTATIONS.GETCURRECNCYUSDT](state, data) {
    state.usdtoinrcurrency = data;
  },
};

// Actions
const actions = {
  //get currency usd to inr
   async [CURRENCY__ACTIONS.GETCURRECNCYUSDT]({ commit, state }) {
    try {
      const response = await HTTP().get(CURRENCY__API.GETCURRECNCYUSDT);
      commit(CURRENCY__MUTATIONS.GETCURRECNCYUSDT, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [CURRENCY__ACTIONS.ACTIVECURRENCIES]({ commit, state }, parameter) {
    try {
      const idParams = parameter?.id != null ? `id=${parameter?.id}` : "";

      const parameterString = [idParams]
        .filter((param) => param !== "")
        .join("&");

      const response = await HTTP().get(
        CURRENCY__API.ACTIVECURRENCIES +
        (parameterString !== "" ? `?${parameterString}` : "")
      );
      commit(CURRENCY__MUTATIONS.ACTIVECURRENCIES, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [CURRENCY__ACTIONS.ACTIVECURRENCYGROUPS]({ commit, state }) {
    try {
      const response = await HTTP().get(CURRENCY__API.ACTIVECURRENCYGROUPS);
      commit(CURRENCY__MUTATIONS.ACTIVECURRENCYGROUPS, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [CURRENCY__ACTIONS.DELETEGROUP]({ commit, dispatch }, parameter) {
    try {
      const response = await HTTP().delete(
        `${CURRENCY__API.DELETEGROUP}?id=${parameter.id}`
      );
      await dispatch(CURRENCY__ACTIONS.ACTIVECURRENCYGROUPS);
      await dispatch(CURRENCY__ACTIONS.ACTIVECURRENCIES);
      if (response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [CURRENCY__ACTIONS.DELETECURRENCY]({ commit, dispatch }, parameter) {
    try {
      const response = await HTTP().delete(
        `${CURRENCY__API.DELETECURRENCY}?id=${parameter.id}`
      );
      await dispatch(CURRENCY__ACTIONS.ACTIVECURRENCIES);
      if (response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [CURRENCY__ACTIONS.UPDATECURRENCYGROUP](
    { commit, dispatch },
    parameter
  ) {
    try {
      const response = await HTTP().put(
        CURRENCY__API.UPDATECURRENCYGROUP,
        parameter
      );
      await dispatch(CURRENCY__ACTIONS.ACTIVECURRENCYGROUPS);
      if (response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  },

  async [CURRENCY__ACTIONS.UPDATECURRENCYSYMBOL](
    { commit, dispatch },
    parameter
  ) {
    try {
      const response = await HTTP().put(
        CURRENCY__API.UPDATECURRENCYSYMBOL,
        parameter
      );
      await dispatch(CURRENCY__ACTIONS.ACTIVECURRENCIES);
      if (response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  },

  async [CURRENCY__ACTIONS.CREATEGROUP]({ commit, dispatch }, parameter) {
    try {
      const response = await HTTP().post(CURRENCY__API.CREATEGROUP, parameter);
      await dispatch(CURRENCY__ACTIONS.ACTIVECURRENCYGROUPS);
      if (response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  },

  async [CURRENCY__ACTIONS.CREATESYMBOL]({ commit, dispatch }, parameter) {
    try {
      const response = await HTTP().post(CURRENCY__API.CREATESYMBOL, parameter);
      await dispatch(CURRENCY__ACTIONS.ACTIVECURRENCIES);
      if (response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  },

  async [CURRENCY__ACTIONS.UPDTECURRENCYUSDT]({ dispatch }, parameter) {
    try {
      const payload = {
        id: parameter.id,
        value: parameter.value,
      };
    // console.log("value",payload);
      const response = await HTTP().post(CURRENCY__API.UPDTECURRENCYUSDT, payload);
      // fetch updated value
      await dispatch(CURRENCY__ACTIONS.GETCURRECNCYUSDT);
      if (response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
